<template>
  <v-dialog :value="modalOpened" transition="dialog-bottom-transition"
            content-class="payment-information" @click:outside="modalOpened = false">
    <template>
      <v-card>
        <div>
          <div style="display: flex; justify-content: center; padding-top: 15px;">
            <v-btn dark class="btn-primary" @click="generatePDF">
              <span>{{ $t('chat.download') }}</span>
            </v-btn>
          </div>

          <div id="pdf" style="padding: 25px; color: black">
            <p align="center"><span><span style="color: black; font-size: small;"><span><strong>CONTRACTE BYPPAY</strong></span></span></span></p>
            <p class="new-line">&nbsp;</p>
            <p><span><span style=" color: black; font-size: small;"><span>{{ myName }}, {{ today }}.</span></span></span></p>
            <p align="center"><span><span style="color: black; font-size: small;"><span><strong>REUNITS</strong></span></span></span></p>
            <p class="new-line">&nbsp;</p>
            <p><span><span style=" color: black; font-size: small;"><span><u>D&rsquo;una part</u></span></span></span><span><span style="color: black;font-size: small;"><span>, la societat {{ nameA }}, amb NIF/CIF {{ nifA }}</span></span></span></p>
            <p class="new-line">&nbsp;</p>
            <p><span><span style="color: black; font-size: small;"><span><u>D&rsquo;una altra part</u></span></span></span><span><span style="color: black;font-size: small;"><span>, la societat {{ nameB }}, amb NIF/CIF {{ nifB }} </span></span></span></p>
            <p class="new-line">&nbsp;</p>
            <p><span><span style="color: black; font-size: small;"><span><u>I d&rsquo;una altra part</u></span></span></span><span><span style="color: black;font-size: small;"><span>, la societat {{ nameC }}, amb NIF/CIF {{ nifC }} </span></span></span></p>
            <p class="new-line">&nbsp;</p>
            <p><span><span style="color: black; font-size: small;"><span>Es reconeixen m&uacute;tua capacitat legal necess&agrave;ria i suficient per a l&rsquo;atorgament del present document i, a l&rsquo;efecte,</span></span></span></p>
            <p class="new-line">&nbsp;</p>
            <p align="center"><span><span style="color: black; font-size: small;"><span><strong>MANIFESTEN</strong></span></span></span></p>
            <p class="new-line">&nbsp;</p>
            <p><span><span style="color: black; font-size: small;"><span>Que {{ nameC }} i {{ nameB }} tenen una relaci&oacute; comercial, sent {{ nameC }} prove&iuml;dor de {{ nameB }}. </span></span></span></p>
            <p class="new-line">&nbsp;</p>
            <p><span><span style="color: black; font-size: small;"><span>Que {{ nameB }} deu a {{ nameC }} la factura n&uacute;mero {{ invoiceNumberBC }}, amb data {{ dateBC }}, per un import de {{ invoiceAmountBC }} euro, amb venciment el dia {{ dueDateBC }}.</span></span></span></p>
            <p class="new-line">&nbsp;</p>
            <p><span><span style="color: black; font-size: small;"><span>Que {{ nameB }} i {{ nameA }} tenen una relaci&oacute; comercial, sent {{ nameA }} client de {{ nameB }}. </span></span></span></p>
            <p class="new-line">&nbsp;</p>
            <p><span><span style="color: black; font-size: small;"><span>Que existeix una factura emesa de {{ nameB }} cap a {{ nameA }}, amb n&uacute;mero {{ invoiceNumberAB }}, amb data {{ dateAB }}, i venciment el dia {{ dueDateAB }} per un import de {{ invoiceAmountAB }} euro. </span></span></span></p>
            <p class="new-line">&nbsp;</p>
            <p lang="es-ES"><span><span style="color: black; font-size: small;"><span>Que totes 3 parts signen aquest contracte de BYPPAY d&rsquo;acord amb les seg&uuml;ents </span></span></span></p>
            <p class="new-line">&nbsp;</p>
            <p class="new-line">&nbsp;</p>
            <p align="center"><span><span style="color: black; font-size: small;"><span><strong>CL&Agrave;USULES</strong></span></span></span></p>
            <p class="new-line">&nbsp;</p>
            <p><span><span style="color: black;font-size: small;"><span><u><strong>PRIMERA.- BYPPAY</strong></u></span></span></span></p>
            <p><span><span style="color: black;font-size: small;"><span>{{ nameA }} es subroga total o parcialment en la posici&oacute; de {{ nameB }} en el deute que {{ nameB }} t&eacute; davant {{ nameC }} per la factura {{ invoiceNumberBC }}, i ho fa per l&rsquo;import de {{ invoiceAmountBC }} euro. Aquest import {{ invoiceAmountBC }} es descomptar&agrave; de l&rsquo;import de la factura {{ invoiceNumberAB }} que {{ nameA }} deu a {{ nameB }}. Les parts acorden que el venciment de la factura {{ invoiceNumberBC }} s&rsquo;amplia a la data {{ dueDateAB }}. </span></span></span></p>
            <p class="new-line">&nbsp;</p>
            <p><span><span style="color: black;font-size: small;"><span><u><strong>SEGONA.- Bonificaci&oacute;</strong></u></span></span></span><u /></p>
            <p><span><span style="color: black;font-size: small;"><span>{{ nameB }} confereix a {{ nameA }} un descompte del {{ discountBA }}% a la factura {{ invoiceNumberAB }} sempre que {{ nameA }} compleixi amb l&rsquo;obligaci&oacute; descrita en la cl&agrave;usula anterior. En cas de no complir-se, desapareixer&agrave; el dret de {{ nameA }} a la bonificaci&oacute;. </span></span></span></p>
            <p><span><span style="color: black;font-size: small;"><span>Aquesta bonificaci&oacute; es reflectir&agrave; amb una factura rectificativa emesa de {{ nameB }} a {{ nameA }} per l&rsquo;import de {{ invoiceAmountAB }} euro. </span></span></span></p>
            <p class="new-line">&nbsp;</p>
            <p><span><span style="color: black;font-size: small;"><span><u><strong>TERCERA.- Responsabilitats</strong></u></span></span></span></p>
            <p><span><span style="color: black;font-size: small;"><span>Entre la firma d&rsquo;aquest contracte i la data {{ dueDateAB }}, es susp&egrave;n la responsabilitat que tingui {{ nameB }} davant {{ nameC }} pel pagament de la factura {{ invoiceNumberBC }}. </span></span></span></p>
            <p><span><span style="color: black;font-size: small;"><span>En cas que, arribada la data {{ dueDateAB }}, {{ nameA }} no hagi procedit al pagament establert a la primera cl&agrave;usula, la suspensi&oacute; de la responsabilitat de {{ nameB }} quedar&agrave; anul&middot;lada, i {{ nameC }} podr&agrave; exigir el pagament a {{ nameB }}. </span></span></span></p>
            <p><span><span style="color: black;font-size: small;"><span>Entre la signatura d&rsquo;aquest contracte i la data {{ dueDateAB }}, es susp&egrave;n l&rsquo;exigibilitat de {{ nameB }} a {{ nameA }} pel pagament de la factura {{ invoiceNumberAB }}. </span></span></span></p>
            <p><span><span style="color: black;font-size: small;"><span>En cas que, arribada la data {{ dueDateAB }}, {{ nameA }} no hagi procedit al pagament establert a la primera cl&agrave;usula, la responsabilitat de {{ nameA }} davant {{ nameB }} es reprendr&agrave;. En aquest cas, la responsabilitat de {{ nameA }} davant {{ nameC }} derivada d&rsquo;aquest contracte, desapareixer&agrave;, i es mant&eacute; la responsabilitat de {{ nameB }} davant {{ nameC }}.</span></span></span></p>
            <p class="new-line">&nbsp;</p>
            <p><span><span style="color: black;font-size: small;"><span><u><strong>QUARTA.-Pagament anticipat</strong></u></span></span></span></p>
            <p><span><span style="color: black;font-size: small;"><span>Si {{ nameB }} proced&iacute;s a fer el pagament de la factura {{ invoiceNumberBC }} de manera anticipada abans de la data {{ dateAB }}, el contracte quedar&agrave; resolt, deixant sense validesa totes les seves cl&agrave;usules. {{ nameB }} s&rsquo;obliga a notificar a {{ nameA }} d&rsquo;aquest pagament anticipat. </span></span></span></p>
            <p class="new-line">&nbsp;</p>
            <p><span><span style="color: black;font-size: small;"><span><u><strong>CINQUENA.- Interessos</strong></u></span></span></span></p>
            <p><span><span style="color: black;font-size: small;"><span>{{ nameB }} s&rsquo;obliga davant {{ nameC }} pels interessos de demora meritats entre la data de venciment {{ dueDateBC }} i la data del pagament del pagament realitzat per {{ nameA }} a {{ nameC }}. Aquest inter&egrave;s ser&agrave; del {{ delayInterestBC }}%. En cas que a la data {{ dueDateAB }} no s&rsquo;hagi realitzat el pagament de {{ nameA }} a {{ nameC }}, els interessos se seguiran meritant a partir d&rsquo;aquell moment. </span></span></span></p>
            <p class="new-line">&nbsp;</p>
            <p><span><span style="color: black;font-size: small;"><span><u><strong>SISENA.-Justificant de pagament</strong></u></span></span></span></p>
            <p><span><span style="color: black;font-size: small;"><span>El pagament per part de {{ nameA }} a {{ nameC }} cancel&middot;lar&agrave; el deute de {{ nameB }} davant {{ nameC }} per l&rsquo;import satisfet per {{ nameA }}, i cancel&middot;lar&agrave; el deute de {{ nameA }} davant {{ nameB }} pel mateix import. Els justificants de pagament, juntament amb aquest contracte, serviran per acreditar el pagament de les factures davant l&rsquo;Administraci&oacute; Tribut&agrave;ria que correspongui. </span></span></span></p>
            <p class="new-line">&nbsp;</p>
            <p><span><span style="color: black;font-size: small;"><span><u><strong>SETENA.- Jurisdicci&oacute;</strong></u></span></span></span><span><span style="font-size: small;"><span><u>.</u></span></span></span></p>
            <p><span><span style="color: black;font-size: small;"><span>Els contractants, a tots els efectes jur&iacute;dics que es derivin de l&rsquo;atorgament d&rsquo;aquest contracte i per a la soluci&oacute; de qualsevol q&uuml;esti&oacute; o litigi que es suscit&eacute;s amb ocasi&oacute; del seu compliment, es sotmeten expressament a la compet&egrave;ncia dels Jutjats i Tribunals de la ciutat de Girona.</span></span></span></p>
            <p class="new-line">&nbsp;</p>
            <p><a name="_GoBack" /> <span><span style="color: black;font-size: small;"><span>I en prova de la seva conformitat, totes les parts signen el present document amb un sol efecte, al lloc i en la data al principi esmentats.</span></span></span></p>
            <p class="new-line">&nbsp;</p>
            <p class="new-line">&nbsp;</p>
            <p><a name="_GoBack" /> <span><span style="color: black;font-size: small;"><span>Signat per </span></span></span></p>
            <p class="new-line">&nbsp;</p>
            <p><a name="_GoBack" /> <span><span style="color: black;font-size: small;"><span>{{ nameA }}                              {{ nameB }}                        {{ nameC }} </span></span></span></p>
            <p class="new-line">&nbsp;</p>
          </div>
        </div>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
import html2pdf from 'html2pdf.js/dist/html2pdf.bundle';
import {User} from "../models/user";
export default {
    name: "GenerateContractByppayPdf",
    components: { },
    props: {
        chat: {
            type: Object,
            default: null
        }
    },
    data () {
        console.log(this.chat);
        return {
            modalOpened: false,
            modelPayer: new User(this.chat.factoring.payer),
            modelMiddle: new User(this.chat.factoring.middle),
            modelReceiver: new User(this.chat.factoring.receiver)
        };
    },
    computed: {
        today () {
            return new Date().toString();
        },
        myName () {
            return (new User(this.$user)).getSingleName();
        },

        nifA () {
            return this.chat.factoring.payer.cif;
        },
        nameA () {
            return this.modelPayer.getSingleName();
        },
        nifB () {
            return this.chat.factoring.middle.cif;
        },
        nameB () {
            return this.modelMiddle.getSingleName();
        },
        discountBA () {
            return ((this.chat.factoring.formulaCalc.earnA * 100) / this.chat.factoring.compensatedPayerAmount).toFixed(2);
        },
        delayInterestBC () {
            return ((this.chat.factoring.formulaCalc.earnC * 100) / this.chat.factoring.compensatedPayerAmount).toFixed(2);
        },
        nifC () {
            return this.chat.factoring.receiver.cif;
        },
        nameC () {
            return this.modelReceiver.getSingleName();
        },
        invoiceNumberBC () {
            return this.chat.factoring.invoice_receiver.number;
        },
        invoiceAmountBC () {
            return this.chat.factoring.formulaCalc.BCini;
        },
        dueDateBC () {
            return this.chat.factoring.invoice_receiver.dueDate.split('T')[0];
        },
        dateBC () {
            return this.chat.factoring.invoice_receiver.date.split('T')[0];
        },

        invoiceNumberAB () {
            return this.chat.factoring.invoice_payer.number;
        },
        invoiceAmountAB () {
            return this.chat.factoring.formulaCalc.ABini;
        },
        dueDateAB () {
            return this.chat.factoring.invoice_payer.dueDate.split('T')[0];
        },
        dateAB () {
            return this.chat.factoring.invoice_payer.date.split('T')[0];
        },
    },
    mounted () {

    },
    methods: {
        onProgress (event) {
            console.log(`Processed: ${event} / 100`);
        },
        hasGenerated () {
            alert("PDF generated successfully!");
        },
        openModal () {
            this.modalOpened = true;
            console.log(this.modalOpened);
            console.log("/////////////////");
            console.log(this.chat.factoring);
            console.log("/////////////////");
        },
        generatePDF: function () {
            const element = document.getElementById('pdf');
            const opt = {
                margin: 10,
                filename: 'myfile.pdf',
                image: {type: 'jpeg', quality: 0.98},
                jsPDF: {unit: 'mm', format: 'a4', orientation: 'p'}
            };
            console.log(element)
            html2pdf(element, opt);
        },
    },
};
</script>

<style scoped>
  .new-line{
    height: 10px;
  }
</style>
